/**
 * ページネーション詳細設定VO
 *
 * @export RegistPageCopyModel
 * @class RegistPageCopyModel
 */
export class RegistPageCopyModel {
  // 媒体区分
  public MediumType = String('');
  // 変更前使用開始受注コード
  public BeforeOrderCode = String('');
  // 変更前基版ページ作成生協コード
  public BeforeCoopCode = String('');
  // 使用開始受注コード
  public OrderCode = String('');
  // 基版ページ作成生協コード
  public CoopCode = String('');
  // 「いばらき」の基版反映先ページ
  public IbarakiPageList: Array<any> = null;
  // 「とちぎ」の基版反映先ページ
  public TochigiPageList: Array<any> = null;
  // 「ぐんま」の基版反映先ページ
  public GunnmaPageList: Array<any> = null;
  // 「ちば」の基版反映先ページ
  public ChibaPageList: Array<any> = null;
  // 「さいたま」の基版反映先ページ
  public SaitamaPageList: Array<any> = null;
  // 「とうきょう」の基版反映先ページ
  public TokyoPageList: Array<any> = null;
  // 「ながの」の基版反映先ページ
  public NaganoPageList: Array<any> = null;
  // 「にいがた」の基版反映先ページ
  public NiigataPageList: Array<any> = null;
  // 「クルコ」の基版反映先ページ
  public KurucoPageList: Array<any> = null;
}
